import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { AssistantWorkspace } from "components/PortalAssistant";
import { useTranslate } from "utils/i18n";
import { figmaTokens } from "assets/theme/designTokens";
import { isAssistantVisible } from "utils/assistantVisibility";

function AssistantPage() {
  const { t } = useTranslate();

  if (!isAssistantVisible()) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox py={3} px={{ xs: 1, sm: 2 }}>
        <SoftBox mb={2}>
          <SoftTypography variant="h5" fontWeight="bold" sx={{ color: figmaTokens.textPrimary }}>
            {t("assistant.page_title", "Assistant eVerifPro")}
          </SoftTypography>
          <SoftTypography variant="button" color="text" fontWeight="regular">
            {t(
              "assistant.page_subtitle",
              "Plein écran — même conversation que le panneau flottant. Réduisez pour revenir."
            )}
          </SoftTypography>
        </SoftBox>
        <SoftBox
          sx={{
            height: { xs: "calc(100dvh - 200px)", md: "calc(100vh - 220px)" },
            minHeight: 480,
          }}
        >
          <AssistantWorkspace />
        </SoftBox>
      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AssistantPage;
